export default "__VITE_ASSET__Dun2rtFX__"